import React from 'react';
const conditions = ['Riesgo suicida', 'Agitación psicomotriz', 'Internación involuntaria', 'Farmacoterapia urgencia', 'Ley 26.657', 'Pase de guardia', 'Documentación legal', 'Crisis psicótica', 'Comunicación familiares', 'Burnout residencia', 'Habeas corpus', 'Responsabilidad médica', 'Contención mecánica', 'Crisis abstinencia', 'Sumario administrativo', 'Alta voluntaria', 'Fuga de paciente', 'Violencia hacia personal'];
const stats = [{
  value: '+560',
  label: 'Páginas',
  color: 'text-white'
}, {
  value: '+80',
  label: 'Protocolos',
  color: 'text-white'
}, {
  value: '6',
  label: 'Tomos',
  color: 'text-white'
}, {
  value: '6',
  label: 'Bonos',
  color: 'text-brand-cta'
}];
export function StatsBar() {
  return <section className="py-8 md:py-16 bg-brand-bg" data-id="element-252">
      <div className="max-w-6xl mx-auto px-4" data-id="element-253">
        <div className="bg-brand-dark rounded-2xl p-4 md:p-10 mb-6 md:mb-10 text-center shadow-xl relative overflow-hidden" data-id="element-254">
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '20px 20px'
        }} data-id="element-255"></div>
          <h2 className="text-white font-heading text-base md:text-2xl mb-4 md:mb-8 relative z-10 px-2" data-id="element-256">
            El sistema más completo para la guardia psiquiátrica
          </h2>
          <div className="grid grid-cols-4 gap-2 md:gap-4 divide-x divide-white/20 relative z-10" data-id="element-257">
            {stats.map((s, i) => <div key={i} className="flex flex-col items-center px-1" data-id="element-258">
                <span className={`text-xl md:text-5xl font-bold mb-0.5 md:mb-2 ${s.color}`} data-id="element-259">
                  {s.value}
                </span>
                <span className="text-blue-200 text-[9px] md:text-sm font-medium uppercase tracking-wider" data-id="element-260">
                  {s.label}
                </span>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-3 md:mb-6" data-id="element-261">
          <h3 className="font-bold text-gray-900 text-sm md:text-base mb-1" data-id="element-262">
            Funciona desde tu primera guardia
          </h3>
          <p className="text-[11px] md:text-sm text-gray-500" data-id="element-263">
            Situaciones cubiertas:
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-1.5 md:gap-3 max-w-4xl mx-auto" data-id="element-264">
          {conditions.map((cond, idx) => <div key={idx} className="bg-[#E8F0F8] text-brand-dark px-2.5 py-1 md:px-4 md:py-2 rounded-full text-[10px] md:text-sm font-medium hover:-translate-y-0.5 hover:bg-blue-100 hover:shadow-sm active:scale-95 transition-all cursor-default" data-id="element-265">
              {cond}
            </div>)}
        </div>
      </div>
    </section>;
}